import 'slick-carousel';

const $slider = $('.js-floating-cards-carousel');

if ($slider.length) {
  $(document).ready(() => {
    initSlider();
    window.addEventListener('resize', initSlider);
  });
}

function initSlider() {
  if ($slider.hasClass('slick-initialized') || window.matchMedia('(min-width: 991px)').matches) {
    return;
  }

  $slider.slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    swipeToSlide: true,
    mobileFirst: true,
    adaptiveHeight: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 991,
        settings: 'unslick',
      },
    ],
  });
}
